module.exports = __webpack_public_path__ + "static/img/map.9b0bb04.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/map.png
// module id = 2Tzo
// module chunks = 1